import { render, staticRenderFns } from "./CopyrightAssignmentTransferFormDetailsEscalated.vue?vue&type=template&id=530e8d45&scoped=true&"
import script from "./CopyrightAssignmentTransferFormDetailsEscalated.vue?vue&type=script&lang=js&"
export * from "./CopyrightAssignmentTransferFormDetailsEscalated.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAssignmentTransferFormDetailsEscalated.vue?vue&type=style&index=0&id=530e8d45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530e8d45",
  null
  
)

export default component.exports